import { MessageProp } from "@/context/redux/reducers/chat-slice";
import { Translation } from "@/data/lang";

import { QuotaButton } from "../components/session-widgets/QuotaButton";

export const getReachLimitSession = ({
  t,
  plan,
  isReachedLimit,
}: {
  t: Translation;
  plan: string;
  isReachedLimit: boolean;
}): (({ quota }: { quota: number }) => MessageProp[]) | null => {
  if (isReachedLimit) {
    if (plan === "Free") {
      return ({ quota }: { quota: number }) => [
        {
          type: "gpt",
          content: t.winwingpt.sessions.reachedFreeQuota({ quota }),
        },
        {
          type: "element",
          content: <QuotaButton />,
        },
      ];
    }

    if (plan.includes("Beginning")) {
      return ({ quota }: { quota: number }) => [
        {
          type: "gpt",
          content: t.winwingpt.sessions.reachedBeginningQuota({ quota }),
        },
        {
          type: "element",
          content: <QuotaButton />,
        },
      ];
    }

    if (plan.includes("Basic")) {
      return ({ quota }: { quota: number }) => [
        {
          type: "gpt",
          content: t.winwingpt.sessions.reachedBasicQuota({ quota }),
        },
        {
          type: "element",
          content: <QuotaButton />,
        },
      ];
    }

    if (plan.includes("Premium")) {
      return ({ quota }: { quota: number }) => [
        {
          type: "gpt",
          content: t.winwingpt.sessions.reachedPremiumQuota({ quota }),
        },
      ];
    }
  }

  return null;
};
